import React from 'react';

import { removePTag } from "../../../../utils/helpers";
import * as HeaderLandingPageStyles from "./header-landing-page.module.scss"

const HeaderLandingPage = ({ headerText }) => {
  return (
    <header className={HeaderLandingPageStyles.header}>
      <div className={HeaderLandingPageStyles.headerLogoLandingPage}>
        <img
          src="/logo_msm.svg"
          alt="logo sito"
          width="303"
          height="62"
        />
      </div>
      <div
        className={HeaderLandingPageStyles.headerTextLandingPage}
        dangerouslySetInnerHTML={{
              __html: removePTag(headerText),
        }}
      >
      </div>
      <div className={HeaderLandingPageStyles.headerLoghiLandingPage}>
        <div className={HeaderLandingPageStyles.headerLoghiLandingPageContainer}>
          <img
              src="/altroconsumo_alt.svg"
              alt="altroconsumo"
              width="152"
              height="31"
              className={HeaderLandingPageStyles.headerLoghiLandingPageImage}
            />
        </div>
        <div className={HeaderLandingPageStyles.headerLoghiLandingPageContainer}>
          <img
              src="/trustpilot-logo_alt.svg"
              alt="trustpilot"
              width="105"
              height="31"
              className={HeaderLandingPageStyles.headerLoghiLandingPageImage}
            />
        </div>
        <div className={HeaderLandingPageStyles.headerLoghiLandingPageContainer}>
          <img
              src="/migliori-optimized-tiny-super.png"
              alt="riconoscimento repubblica"
              width="55"
              height="80"
            />
        </div>
      </div>
    </header>
  );
};

export default HeaderLandingPage;
